import _classCallCheck from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import { Entity, Guard, Result } from '@digibricks/domains';
export var QuestionReport = /*#__PURE__*/function (_Entity) {
  _inherits(QuestionReport, _Entity);

  var _super = _createSuper(QuestionReport);

  function QuestionReport() {
    _classCallCheck(this, QuestionReport);

    return _super.apply(this, arguments);
  }

  _createClass(QuestionReport, [{
    key: "sectionId",
    get: function get() {
      return this.props.sectionId;
    }
  }, {
    key: "questionId",
    get: function get() {
      return this.props.questionId;
    }
  }, {
    key: "isBookmarked",
    get: function get() {
      return this.props.isBookmarked;
    }
  }, {
    key: "type",
    get: function get() {
      return this.props.type;
    }
  }, {
    key: "updateBookmark",
    value: function updateBookmark() {
      this.props.isBookmarked = !this.props.isBookmarked;
    }
  }], [{
    key: "createBaseProps",
    value: function createBaseProps(props) {
      var collection = [{
        argument: props.id,
        argumentName: 'Answer Id'
      }, {
        argument: props.sectionId,
        argumentName: 'Section Id'
      }, {
        argument: props.questionId,
        argumentName: 'Question Id'
      }, {
        argument: props.type,
        argumentName: 'Type'
      }];
      var guardCollectionResult = Guard.againstNullOrUndefinedBulk(collection);

      if (!guardCollectionResult.succeeded) {
        return Result.fail(guardCollectionResult.message);
      }

      return Result.ok(props);
    }
  }]);

  return QuestionReport;
}(Entity);